import { createFileRoute, notFound } from '@tanstack/react-router';

import { createQueryLoader, getServerQueryResponse } from '@/loader';
import DirectoryTownPageQueryNode, {
  type DirectoryTownPageQuery,
} from '@/pages/directory/__generated__/DirectoryTownPageQuery.graphql';
import DirectoryTownPage from '@/pages/directory/DirectoryTownPage';
import {
  getDirectoryTown,
  getDirectoryTownByAreaSlug,
} from '@/sanity/directory';
import { getFooterLandingPages } from '@/sanity/landing-page';
import { getLegalLinks } from '@/sanity/legal-document';

const loadDirectoryTown = createQueryLoader<DirectoryTownPageQuery>(
  DirectoryTownPageQueryNode,
  { fetchPolicy: 'store-or-network' },
);

export const Route = createFileRoute('/letting-agents/$townSlug')({
  loader: async ({ context, params }) => {
    const [townBySlug, townByArea, footerLandingPages, footerLegalLinks] =
      await Promise.all([
        getDirectoryTown({ data: params.townSlug }),
        getDirectoryTownByAreaSlug({ data: params.townSlug }),
        getFooterLandingPages(),
        getLegalLinks(),
      ]);
    const town = townBySlug ?? townByArea;
    const areaSlug = townBySlug?.directoryAreaSlug || params.townSlug;
    const queryData = await loadDirectoryTown({
      environment: context.relayEnvironment,
      variables: { areaSlug },
    });
    const serverResponse = getServerQueryResponse(queryData);
    const area = serverResponse?.landlordDirectoryArea;
    if (serverResponse && !area && !town) {
      throw notFound();
    }

    return {
      footerLandingPages,
      footerLegalLinks,
      queryData,
      town,
    };
  },
  component: DirectoryTownPage,
});
